import { Controller, useFormContext } from 'react-hook-form'

import { FF2, TextInput } from 'ui/components'
import { SarEdit } from '~bank-bsa-reporting/types'

export const SecuritiesOther = () => {
  const { control } = useFormContext<SarEdit>()

  return (
    <Controller
      name="suspiciousActivityInfo.securitiesOther"
      control={control}
      render={({ field }) => <FF2 field={field} input={(props) => <TextInput {...props} />} />}
    />
  )
}
